let filesArray = [];

$('#file-dropzone').on('click', () => $('#attachments').click());

$('#attachments').on('change', function () {
	handleFiles(this.files);
});

$('#file-dropzone').on('dragover', function(e){
	e.preventDefault();
	$(this).addClass('dragover');
}).on('dragleave drop', function(){
	$(this).removeClass('dragover');
}).on('drop', function(e){
	e.preventDefault();
	handleFiles(e.originalEvent.dataTransfer.files);
});

function handleFiles(files) {
	for (let file of files) {
		if (!file.type.match('image.*') && file.type !== 'application/pdf') continue;

		filesArray.push(file);
		renderPreview(file, filesArray.length - 1);
	}

	updateInputFiles();
}

function renderPreview(file, index) {
	let reader = new FileReader();
	let thumb = $('<div class="file-thumb"></div>');

	let removeBtn = $('<button>&times;</button>').on('click', function(){
		filesArray.splice(index, 1);
		thumb.remove();
		updateInputFiles();
	});

	thumb.append(removeBtn);

	if (file.type === 'application/pdf') {
		thumb.append('<div class="pdf">PDF</div>');
	} else {
		reader.onload = e => thumb.append('<img src="'+e.target.result+'">');
		reader.readAsDataURL(file);
	}

	thumb.append('<div>'+file.name+'</div>');
	$('#file-preview').append(thumb);
}

function updateInputFiles() {
	const dt = new DataTransfer();
	filesArray.forEach(f => dt.items.add(f));
	$('#attachments')[0].files = dt.files;
}